/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_SocialInputs */

const en_landing_pricing_compare_social = /** @type {(inputs: Landing_Pricing_Compare_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social media promotion`)
};

const zh_landing_pricing_compare_social = /** @type {(inputs: Landing_Pricing_Compare_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社交媒体推广`)
};

/**
* | output |
* | --- |
* | "Social media promotion" |
*
* @param {Landing_Pricing_Compare_SocialInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_social = /** @type {((inputs?: Landing_Pricing_Compare_SocialInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_SocialInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_social(inputs)
	return zh_landing_pricing_compare_social(inputs)
});
export { landing_pricing_compare_social as "landing.pricing.compare_social" }